import type { Article } from '@b2ag/micro-front-articles/types'
// TODO XJU - à refactoré pour tout passer dans le micro-front-articles
import { contentfulContentToArticle } from '@b2ag/micro-front-articles/mapper'
import type ContentfulClient from '@b2ag/contentful'
import type { IArticlesRepository } from '../../domain/repository/IArticlesRepository'
import { i18n } from '@b2ag/locale'

export class ArticlesRepository implements IArticlesRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(public readonly client: ContentfulClient) {}

  getAllByPartnerId(partnerId: number): Promise<Article[]> {
    return this.client.api.withoutUnresolvableLinks
      .getEntries({
        content_type: 'richBox',
        'fields.partnerId': partnerId,
        order: ['-fields.publishedAt'],
        locale: i18n.locale,
      })
      .then((content) => {
        return content.items.map(contentfulContentToArticle)
      })
  }

  getAnchoredArticlesByPartnerId(partnerId: number): Promise<Article[]> {
    return this.client.api.withoutUnresolvableLinks
      .getEntries({
        content_type: 'richBox',
        'fields.partnerId[exists]': false,
        'fields.partnerFilter[in]': partnerId,
        order: ['-fields.publishedAt'],
        locale: i18n.locale,
      })
      .then((content) => {
        return content.items.map(contentfulContentToArticle)
      })
  }
}
